// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__De0Qd","label":"MGChip_label__TJRXI","iconLeft":"MGChip_iconLeft__Ror6s","iconRight":"MGChip_iconRight__OXn12"};